<template>
    <div class="wrap-input gender-base" :class="addClass">
        <label class="label"
            :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
            >{{label}}</label>
        <div class="gender-radio">
            <div class="gender-flex"
                 v-for="(item) in itemList"
                 :key="item.value"
                 @click="selectRadio(item.value)">
                <div class="gender-icon" v-if="item.value == content">
                    <img :src="require(`../../assets/radio/${item.active}`)">
                </div>
                <div class="gender-icon" v-else>
                    <img :src="require(`../../assets/radio/${item.inactive}`)">
                </div>
                <div class="gender-label"
                     :class="{'error': isError}">
                    {{item.text}}
                </div>
            </div>
        </div>
        <div class="error-text" v-show="isError">
            {{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";

/**
 * @property {Object} inputLbl (required) Text for component.
 * @property {Array} itemList (required) example : { text: '', value: ''}
 * @property {Boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {String} addClass (optional) Add css class
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {String|Number} setValue (optional) Set default value
 */
export default {
    name: "RadioGender",
    props: {
        inputLbl: { type: Object, required: true },
        itemList: { type: Array, required: true },
        errorInfo: { type: Object, required: true },
        addClass: { type: String, required: false },
        isFirstSave: {
            type: Boolean,
            required: false,
            default: false,
        },
        isShowErrorLbl: {
            type: Boolean,
            required: false,
            default: false,
        },
        setValue: {
            type: [String, Number],
            required: false,
        },
    },
    data: function() {
        return {
            content: '',
            customClass: '',
            label: ''
        };
    },
    created: function() {
        this.customClass = this.addClass == null ? '' : this.addClass;
        this.content = this.setValue;
        this.validate();
    },
    mounted: function()  {
        this.label = this.inputLbl.name;
    },
    computed: {
        isError: function() {
            return !this.isFirstSave
                && this.isShowErrorLbl
                && !this.errorInfo.isValid;
        },
    },
    methods: {
        selectRadio: function(value) {
            this.content = value;
            this.validate();
            this.$emit('input', value);
        },
        validate: function() {
            if(!this.inputLbl) {
                return;
            }
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';

            if (this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/Input/Radio.scss";

.gender-base{
    // .label{
    //     font-family: "DBHeaventRegular";
    //     font-size: 1.5rem;
    //     color: #999999;
    // }
    width: 100%;
    margin: {
        top: 15px;
        bottom: 15px;
    }

    .gender-radio {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;

        .gender-flex {
            display: flex;
            align-items: flex-start;

            .gender-icon {
                display: flex;
                justify-content: center;
                width: 1.25rem;
                margin-top: 5px;


                img {
                    width: 100%;
                }
            }

            .gender-label {
                font-family: "DBHeaventRegular";
                font-size: 1.5rem;
                color: #666666;
                
                margin: {
                    left: 10px;
                };

                &.error {
                    color: #e73030;
                }
            }
        }
    }
}
</style>
